import { render, staticRenderFns } from "./Hexagon.vue?vue&type=template&id=53da0155&"
import script from "./Hexagon.vue?vue&type=script&lang=js&"
export * from "./Hexagon.vue?vue&type=script&lang=js&"
import style0 from "./Hexagon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports